import React from 'react';
import { Grid, withStyles } from '@material-ui/core';
import styles from './style';
import defaultBanner from '../defaultBanner';
import Label, { LabelContainer } from "storybookComponents/EditableLabel"
import Button from 'storybookComponents/Button';
import ImageChanger from "./imageChanger";
import TextEditor from "components/TextEditor";
import Icon from "storybookComponents/Icon";
import IconComponent from "components/IconComponent"
import { DeleteIcon, AttachIcon } from "icons"
import "./style.css"

export default withStyles(styles)(
  ({ values, setFieldValue, classes, id, showNotification, pdfFileName, setPdfFileName }) => {
    const [inputFile, setInputFile] = React.useState();
    const [focus, setFocus] = React.useState(false);
    const updateImage = (imageData) => {
      setFieldValue("imageData", imageData);
    };
    const handleFocus = () => {
      setFocus(true);
    };
    const handleBlur = () => {
      setFocus(false);
    };
    const convertBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    };
    const handleFileClick = () => {
      let element = document.getElementById("hyEvent-fileUploader");
      if (element) {
        element.click();
      }
    };

    const onFileChange = async (event) => {
      if (event.target.files[0].size > 6291456) {
        showNotification("Upload failed. Please upload a PDF less than 6MB.", "error");
        return;
      }
      setInputFile(event.target.files[0]);
      const base64 = await convertBase64(event.target.files[0]);
      setFieldValue("docData", base64);
      setFieldValue("pdfFileName", event.target.files[0].name);
    };
    const onFileRemove = (event) => {
      let element = document.getElementById("hyEvent-fileUploader");
      if (element) {
        element.value = null;
      }
      setInputFile("");
      if (id) {
        setFieldValue("docData", "delete");
      } else {
        setFieldValue("docData", null);
      }
      setFieldValue("pdfFileName", null);
    };
    return (
      <div>
        <div className={`banner-container ${classes.imageButtonContainer}`}>
          <img src={values.imageData || defaultBanner} style={{ width: "100%", maxHeight: 340 }} />
          <div className="banner-overlay">
            <ImageChanger
              base64
              showNotification={showNotification}
              onChange={updateImage}
              customButton={
                <Button
                  color="hylyBlue"
                  className={classes.changeButton}
                  variant="secondary"
                  size="md"
                >
                  Change Image
                </Button>
              }
            />
          </div>
        </div>
        <div className={classes.bannerBottom}>
          <LabelContainer className={classes.labelContainer}>
            <Label
              name="Subtitle"
              keyName="messageTitle"
              handleBlur={setFieldValue}
              className={classes.subtitleClass}
              text={values.messageTitle}
            />
          </LabelContainer>
          <div
            className={`${classes.textEditor} edit-text-editor ${focus && classes.textEditorFocused
              }`}
          >
            <TextEditor
              onFocus={handleFocus}
              setToolbarVisible
              value={values.message}
              onChange={(html) => setFieldValue("message", html)}
              onBlur={handleBlur}
            />
            <div className="edit-text-editor-pencil">
              <Icon type="icon-pencil" size="md" />
            </div>
          </div>
          <input
            type="file"
            id="hyEvent-fileUploader"
            className={classes.inputStyle}
            accept="application/pdf"
            onChange={onFileChange}
          />
          <div
            className={`${classes.fileAttachContainer} ${inputFile || values.pdfFileName ? classes.afterSelection : classes.cursorStyle
              }`}
          >
            <div
              onClick={!values.pdfFileName && !inputFile ? handleFileClick : () => { }}
              className={classes.flexContainer}
            >
              <AttachIcon />
              <div
                className={`${inputFile || values.pdfFileName ? classes.fileName : classes.attachFile
                  }`}
              >
                {!inputFile && !values.pdfFileName
                  ? "Attach a file"
                  : inputFile
                    ? inputFile.name
                    : values.pdfFileName}
              </div>
            </div>
            {inputFile || values.pdfFileName ? (
              <IconComponent
                className={classes.deleteContainer}
                Component={DeleteIcon}
                onHoverColor="#E75F75"
                onClick={onFileRemove}
              />
            ) : (
              <div className={classes.messageBottom}>(less than 6MB)</div>
            )}
          </div>
        </div>
      </div>
    );
  }
);
